import { useEffect, useState } from "react";
import { Image, Typography, Button, Row, Col, Spin, Empty, Rate } from "antd";
import { useNavigate } from "react-router-dom";
import { getProjects } from "../../../api/projects.module";
import { Helmet } from "react-helmet";
import ReactHelmet from "../../../helpers/ReactHelmet";
const { Paragraph, Text } = Typography;

function Projects({ screenWidth }) {
  const [projects, setProjects] = useState("");
  const navigate = useNavigate();
  const fetchProjects = async () => {
    try {
      const dt = await getProjects();
      if (dt) {
        setProjects(dt);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchProjects();
  }, []);
  return (
    <div>
      <ReactHelmet
        title="Projects"
        content={`An overview of my Projects, where I deploy ReactJS, NextJs to achieve achieve client goals`}
      />
      <Paragraph
        style={{
          fontSize: "1.5rem",
          margin: "0 0 2rem 0",
          textAlign: "center",
        }}
        strong
      >
        COMPLETED{" "}
        <Text style={{ color: "#0abacc", fontSize: "1.5rem" }}>PROJECTS</Text>
      </Paragraph>
      <Paragraph
        style={{
          border: "1px solid #D04A1060",
          // background: "#D04A1010",
          padding: screenWidth < 800 ? "1rem " : "1vh 1vw",
          textAlign: "left",
          borderRadius: "7px",
          // color: "#000000",
          fontSize: "14px",
        }}
        ellipsis={{ rows: 3, expandable: true, symbol: "more" }}
      >
        If you have a project idea but have faced challenges in securing the
        expertise of a professional full-stack developer to bring it to
        fruition, you've come to the right place. I'm well-equipped to cover
        your project needs with the skills and proficiency required for
        successful development and implementation.
      </Paragraph>
      <Row>
        {!projects ? (
          <Paragraph
            style={{
              textAlign: "center",
              padding: "4rem",
              width: "100%",
              lineHeight: 1.5,
            }}
          >
            <Spin size="45" /> Loading ...
          </Paragraph>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
            }}
          >
            {projects.length < 1 ? (
              <Empty description="No adds available!" />
            ) : (
              <>
                {projects.map((project) => (
                  <div
                    style={{
                      width: screenWidth < 500 ? "100%" : "280px",
                      border: "1px solid #cccccc30",
                      margin: "0.1rem 0.4rem",
                      borderRadius: "5px 5px 0 0",
                      background: "#fff",
                    }}
                    key={project.id}
                  >
                    <Image
                      src={project.images[0]}
                      alt="bgimahood"
                      preview={false}
                      style={{
                        borderRadius: "7px 7px 0 0",
                        width: "100%",
                        // maxWidth: "220px",
                        minHeight: "150px",
                        // maxHeight: "180px",
                        // background: "#49b",
                        margin: 0,
                        overflow: "hidden",
                      }}
                    />
                    <div
                      className="card-body"
                      style={{
                        padding: screenWidth < 800 ? "1rem" : "0 0.8rem",
                      }}
                    >
                      <Paragraph
                        style={{
                          color: "#0c6f8d",
                          // background:"#b12",
                          // lineHeight: 1,
                          paddingTop: "1vh",
                          fontSize: "14px",
                          margin: "0.2rem 0",
                        }}
                        strong
                        ellipsis={{
                          rows: 1,
                          expandable: false,
                        }}
                      >
                        {project.title}
                      </Paragraph>
                      <Paragraph
                        ellipsis={{
                          rows: 2,
                          expandable: false,
                        }}
                        style={{ fontSize: "12px", color: "gray" }}
                      >
                        {project.description}
                      </Paragraph>
                      <Rate defaultValue={4} disabled />
                      <Paragraph style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => navigate(`/projects/${project.id}`)}
                        >
                          View Demo
                        </Button>
                      </Paragraph>
                    </div>
                  </div>
                ))}{" "}
              </>
            )}
          </div>
        )}
      </Row>
    </div>
  );
}

export default Projects;
